/**
 *日期时间戳转换成yyyy-MM-dd
 */
export default function timestampToDateFtr(input) {
	if (input !== undefined) {
        let date=new Date(input);
        let year=date.getFullYear();
        let month=date.getMonth()+1;
        let day=date.getDate();
		
		return year+'-'+month+"-"+day;
	}
	return input;
}


// WEBPACK FOOTER //
// ./src/modules/filter/timestampToDateFtr.js